export default __webpack_public_path__ + "static/media/ic_remove.4f26bdb6.svg";